import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TokenInterceptor } from '@shared/interceptors/token.interceptor';
import { provideApollo } from 'apollo-angular';
import { routes } from './app.routes';
import { provideCoreInit } from './core/core.provider';
import { ChunkErrorHandler } from './core/handlers/chunk-error.handler';
import { P_JKIT_TOUR_TEXTS, P_JKIT_TOURS, P_TOURS_STORAGE_KEY } from './tour/p-tour-config';
import { PTourPersistenceService } from './tour/tour-persistence.service';
import { provideJKitTours } from './tour/tour.service';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideHttpClient(withInterceptorsFromDi()),
		provideRouter(routes),
		provideCoreInit(),
		provideAnimations(),
		provideApollo((() => {}) as any),
		provideJKitTours({
			tours: P_JKIT_TOURS,
			texts: P_JKIT_TOUR_TEXTS,
			storeTo: 'mixed',
			storageKey: P_TOURS_STORAGE_KEY,
			dismissible: false,
			persistence: PTourPersistenceService
		}),
		DecimalPipe,
		DatePipe,
		CurrencyPipe,
		{ provide: ErrorHandler, useClass: ChunkErrorHandler },
		{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
	]
};
